module.exports = __webpack_public_path__ + "static/img/04.61a115f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/ddejc/04.png
// module id = pbaA
// module chunks = 0